/**
 * 系统相关接口-网校搬运
 */

import { API, http } from './index';
import Vue from 'vue';
import { TENANT_ID } from '@/store/mutation-types';

/**
 * 刷新缓存
 * @returns {Promise<*>}
 */
export const refreshCache = () => http.get(API.manage.refreshCache, {});

/**
 * 查询字典
 * @returns {Promise<*>}
 */
export const queryAllDictItems = () => http.get(API.manage.queryAllDictItems, {});

/**
 * 根据字典code查询字典
 * @param dictCode
 * @returns {Promise<*>}
 */
export const queryDictItems = dictCode => http.get(`${API.manage.queryDictItems}${dictCode}`, {});

/**
 * 查询部门树形结构列表（无参）
 * @returns {Promise<*>}
 */
export const queryDepartTreeList = () => http.get(API.manage.queryDepartTreeList, {});

/**
 * 输入搜索部门
 * @type {function(): Promise<*>}
 */
export const searchDepartByKeywords = data => http.get(API.manage.searchDepartByKeywords, data);

/**
 * 字段值是否可用校验
 * @param data
 * @returns {Promise<*>}
 */
export const duplicateCheck = data => {
    const options = {
        method: 'get',
        params: data,
        isNoMessage: true,
    };
    return http.request(API.manage.duplicateCheck, options);
};

/**
 * 是否重复校验（商户内唯一）
 * @param data
 * @returns {Promise<*>}
 */
export const duplicateCheckByTenantId = data => {
    if (!data.tenantIdField) {
        data.tenantIdField = 'tenant_id';
    }
    if (!data.tenantId) {
        data.tenantId = Vue.ls.get(TENANT_ID);
    }
    const options = {
        method: 'get',
        params: data,
        isNoMessage: true,
    };
    return http.request(API.manage.duplicateCheckByTenantId, options);
};

/**
 * 加载树数据
 * @param data
 * @returns {Promise<*>}
 */
export const loadTreeData = data => http.get(API.manage.loadTreeData, data);

export const loadDictItem = (dict, data) => http.get(`${API.manage.loadDictItem}${dict}`, data);

/**
 * 菜单权限树
 * @returns {Promise<*>}
 */
export const queryRoleTreeList = () => http.get(API.manage.queryRoleTreeList, {});

/**
 * 部门Tree Data
 * @param data
 * @returns {Promise<*>}
 */
export const queryDepartTreeData = data => http.get(API.manage.queryDepartTreeData, data);

/**
 * 查询未设置未老师的用户列表
 * @param params
 * @param extra
 * @returns {Promise<unknown>}
 */
export const getNoTeacherList = ({ params, extra }) => http.get(API.manage.getNoTeacherList, params, { extra });

/**
 * 富文本 上传
 * @param url
 * @param data
 * @returns {Promise<unknown>}
 */
export const uploadAction = (url, data) => {
    const options = {
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data', // 文件上传
        },
        data,
    };
    return http.request(url, options);
};

/**
 * 获取所有区域信息
 * @param data
 * @param extra
 * @returns {Promise<unknown>}
 */
export const getRegionOptions = ({ data, extra }) =>
    http.get(API.manage.getRegionOptions, data || {}, { extra: extra || {} });

/**
 * 订单：计算折算后流水
 * @param data
 * @returns {*}
 */
export const autoCalculateFlowingWater = data => http.post(API.manage.autoCalculateFlowingWater, data);

/**
 * 根据息率计算折算后流水
 * @param data
 * @returns {*}
 */
export const calculateFlowingWaterByRate = data => http.post(API.manage.calculateFlowingWaterByRate, data);

/**
 * 订单：校验支付订单号是否重复
 * @param data
 * @returns {*}
 */
export const payOrderNoUniqueCheck = data => http.post(API.manage.payOrderNoUniqueCheck, data);

/**
 * 获取区域信息
 * @param flag
 * @returns {Promise<*>}
 */
export const getRegionTreeList = async (flag = false,params) => {
    let regionList = Vue.ls.get('region_list');
     console.log(157,params,regionList);
    if (flag || !regionList) {
        // 重新请求接口
        console.log(160,flag,regionList,params);
        return http.get(API.manage.getRegionTreeList, params).then(res => {
            regionList = res.result;
            console.log(777,regionList)
            Vue.ls.set('region_list', res.result);
            return regionList;
        });
    }
    else {
        return regionList;
    }
};

/**
 * 加密字段可选列表
 * @param extra
 * @returns {*}
 */
export const getEncryptFieldList = extra => http.get(API.manage.getEncryptFieldList, {}, { extra });

/**
 * 登录用户加密字段集合
 * @returns {Promise<unknown>}
 */
export const getAllEncryptFieldList = () => http.get(API.manage.getAllEncryptFieldList, {});


/**
 * 根据code查询字段选项的值
 * @returns {Promise<unknown>}
 */
export const queryOptionArrayByFieldCode = params => http.get(API.manage.queryOptionArrayByFieldCode, params, {}).then(res => {
    res.result.length && res.result.forEach(item => {
        item.value = item.value.toString();
    });
    return res;
});




// 我的消息-参考crm改造--------------------------------------------------------------------------------------------------
export const getAction = (url, params) => http.get(url, params).then(res => res);
export const putAction = (url, params) => http.put(url, params).then(res => res);
export const deleteAction = (url, params) => http.delete(url, params).then(res => res);
// 发送用户在线通知
export const updateUserNewestOnlineDate = userId => http.post(`${API.message.updateUserNewestOnlineDate}?userId=${userId}`, {});
// 退费驳回数量书记
export const postRefundData = filterId => http.post(`${API.message.refundData}`, {filterId});

// 字典标签专用（通过code获取字典数组）
export const ajaxGetDictItems = (code, params) => getAction(`/sys/dict/getDictItems/${code}`, params);

// 从缓存中获取字典配置
export const getDictItemsFromCache = function(dictCode) {
    if (Vue.ls.get(TENANT_ID) && Vue.ls.get(TENANT_ID)[dictCode]) {
        let dictItems = Vue.ls.get(TENANT_ID)[dictCode];
        console.log(`-----------getDictItemsFromCache----------dictCode=${  dictCode  }---- dictItems=`, dictItems);
        return dictItems;
    }
};

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url, parameter) {
    return http.get(url, parameter, {responseType: 'blob'}).then(res => res);
}

/**
 * 获取文件服务访问路径
 * @param avatar
 * @param subStr
 * @returns {*}
 */
export function getFileAccessHttpUrl(avatar, subStr) {
    if (!subStr)
        subStr = 'http';
    try {
        if (avatar && avatar.startsWith(subStr)) {
            return avatar;
        }
        else {
            if (avatar && avatar.length > 0 && avatar.indexOf('[') == -1) {
                return `${window._CONFIG['staticDomainURL']  }/${  avatar}`;
            }
        }
    }
    catch (err) {
        return;
    }
}


/**
 * 日志管理
 * @returns {Promise<*>}
 */
export const logList = data => http.get(API.manage.logList, data);


/**
 * 查询全部省份信息
 * @returns {Promise<*>}
 */
export const queryAllProvince = data => http.get(API.manage.queryAllProvince, data);

export default {
    refreshCache,
    queryAllDictItems,
    queryDictItems,
    queryDepartTreeList,
    searchDepartByKeywords,
    duplicateCheck,
    loadTreeData,
    loadDictItem,
    queryRoleTreeList,
    queryDepartTreeData,
    getNoTeacherList,
    getRegionOptions,
    autoCalculateFlowingWater,
    calculateFlowingWaterByRate,
    payOrderNoUniqueCheck,
    getRegionTreeList,
    getEncryptFieldList,
    getAllEncryptFieldList,
    queryOptionArrayByFieldCode,
    logList,
    queryAllProvince
};
